var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSideNewsLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1996_41709)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.4141 4.72656H14.9609V1.25C14.9609 0.926406 14.6986 0.664062 14.375 0.664062H0.585938C0.262344 0.664062 0 0.926406 0 1.25V16.4062C0 18.0217 1.31426 19.3359 2.92969 19.3359H17.0703C18.6857 19.3359 20 18.0217 20 16.4062V5.3125C20 4.98891 19.7377 4.72656 19.4141 4.72656ZM2.92969 18.1641C1.96043 18.1641 1.17188 17.3755 1.17188 16.4062V1.83594H13.7891C13.7891 17.3229 13.7817 16.4619 13.8025 16.6827C13.8534 17.2259 14.056 17.7381 14.3764 18.1641H2.92969ZM18.8281 16.4062C18.8281 17.3755 18.0396 18.1641 17.0703 18.1641C16.9388 18.1641 16.8479 18.1641 16.7188 18.1641C15.7495 18.1641 14.9609 17.3755 14.9609 16.4062V5.89844H18.8281V16.4062Z",
    fill: "#EEF4FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.875 3.47656H3.125C2.80141 3.47656 2.53906 3.73891 2.53906 4.0625C2.53906 4.38609 2.80141 4.64844 3.125 4.64844H11.875C12.1986 4.64844 12.4609 4.38609 12.4609 4.0625C12.4609 3.73891 12.1986 3.47656 11.875 3.47656Z",
    fill: "#EEF4FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.875 5.97656H3.125C2.80141 5.97656 2.53906 6.23891 2.53906 6.5625C2.53906 6.88609 2.80141 7.14844 3.125 7.14844H11.875C12.1986 7.14844 12.4609 6.88609 12.4609 6.5625C12.4609 6.23891 12.1986 5.97656 11.875 5.97656Z",
    fill: "#EEF4FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.875 15.3516H3.125C2.80141 15.3516 2.53906 15.6139 2.53906 15.9375C2.53906 16.2611 2.80141 16.5234 3.125 16.5234H11.875C12.1986 16.5234 12.4609 16.2611 12.4609 15.9375C12.4609 15.6139 12.1986 15.3516 11.875 15.3516Z",
    fill: "#EEF4FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.875 8.47656H7.5C7.17641 8.47656 6.91406 8.73891 6.91406 9.0625V13.4375C6.91406 13.7611 7.17641 14.0234 7.5 14.0234H11.875C12.1986 14.0234 12.4609 13.7611 12.4609 13.4375V9.0625C12.4609 8.73891 12.1986 8.47656 11.875 8.47656ZM11.2891 12.8516H8.08594V9.64844H11.2891V12.8516Z",
    fill: "#EEF4FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.125 10.5859H5C5.32359 10.5859 5.58594 10.3236 5.58594 10C5.58594 9.67641 5.32359 9.41406 5 9.41406H3.125C2.80141 9.41406 2.53906 9.67641 2.53906 10C2.53906 10.3236 2.80141 10.5859 3.125 10.5859Z",
    fill: "#EEF4FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.125 13.0859H5C5.32359 13.0859 5.58594 12.8236 5.58594 12.5C5.58594 12.1764 5.32359 11.9141 5 11.9141H3.125C2.80141 11.9141 2.53906 12.1764 2.53906 12.5C2.53906 12.8236 2.80141 13.0859 3.125 13.0859Z",
    fill: "#EEF4FB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1996_41709"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideNewsLogo);
export default __webpack_public_path__ + "static/media/side_news_logo.bc92da2a7232a1a1f4cb0efb3553a819.svg";
export { ForwardRef as ReactComponent };